/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, February 17th 2022, 1:17:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Identifier } from "dnd-core";
import { CustomDragLayer, useOSCustomDragLayer } from "ui-widgets/drag-and-drop";
import { PrimaryKeyValue } from "lib/types";
import React from "react";
import { isEmpty } from "lodash";
import { DraggedListItemState } from "ui-widgets/drag-and-drop/dnd-list/useDragDropListItem";

interface PreviewComponentProps<T> {
  item: T;
}

interface ListItemDragLayerProps<T> extends Pick<React.HTMLProps<HTMLDivElement>, "className"> {
  findItem: (id: PrimaryKeyValue<T>) => { item: T; index: number };
  itemType: Identifier;
  PreviewComponent: (props: PreviewComponentProps<T>) => JSX.Element;
}

export const ListItemDragLayer = <T,>({ findItem, itemType, PreviewComponent }: ListItemDragLayerProps<T>) => {
  const { collectedProps } = useOSCustomDragLayer<DraggedListItemState<T>>({
    itemType,
  });

  const item = collectedProps?.item;

  const draggedItem: T = findItem(item?.draggedItemId)?.item;

  return !isEmpty(draggedItem) ? (
    <CustomDragLayer collectedProps={collectedProps}>
      <PreviewComponent item={draggedItem} />
    </CustomDragLayer>
  ) : null;
};
